import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { WorkflowApiService } from '../../services/workflow-api.service';
import { Button } from 'primeng/button';
import { Position } from 'src/app/features/orders/models/position.model';
import { Order } from 'src/app/features/orders/models/order.model';
import { PositionWorkflow } from '../../models/workflow-status.enum';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-workflow-actions',
  providers:[],
  imports: [Button],
  templateUrl: './workflow-actions.html'
})
export class WorkflowActionsComponent extends AbstractComponent{
  position = input<Position>();
  state = input<number>();
  substate = input<number>();
  order = input<Order>();
  disabled = input<boolean>(false);
  
  updated = output<void>();

  private api = inject(WorkflowApiService);


  public positionWorkflowState = computed(()=>{
      const state = this.state();
      return PositionWorkflow.list!.find(x=> x.id==state); 
    })

  public positionWorkflowSubState = computed(()=>{
    const positionWorkflowState = this.positionWorkflowState();
    if(!positionWorkflowState) return;
    const substate = this.substate();
    console.log('positionWorkflowState:', positionWorkflowState);
    return positionWorkflowState.list!.find(x=> x.id==substate); 
  })

  async run(action: string, id: number) {
    await this.api.execute(action, id)
    this.updated.emit();
  }
}